// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import map from 'lodash/map'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import has from 'lodash/has';
import { MigrationError } from '@nerdwallet/structured-content-core/migrations';
import { ACCORDION } from '../../../types';
import { ACCORDIONITEM } from '../../../types/deprecated'; // migration follows removal of the `AccordionItem` type from schema

export default function migrateAccordionFrom_1_0_0_to_2_0_0(_ref) {
  var type = _ref.type,
      version = _ref.version,
      props = _ref.props;
  var panels = map(props.children, function (childNode) {
    if (version !== '1.0.0') throw new MigrationError("".concat(ACCORDION, " v2.0.0 migrator should only operate on ").concat(ACCORDION, " v1.0.0 nodes, got: v").concat(version)); // eslint-disable-line prettier/prettier

    if (has(childNode, 'type') === false) throw new MigrationError("".concat(ACCORDION, " 1.0.0 should only have structured-content nodes as children.")); // eslint-disable-line prettier/prettier

    if (childNode.type !== ACCORDIONITEM) throw new MigrationError("".concat(ACCORDION, " 1.0.0 children should only have nodes of type: '").concat(ACCORDIONITEM, "'.")); // eslint-disable-line prettier/prettier

    return childNode.props;
  });
  return {
    type: type,
    version: '2.0.0',
    props: {
      panels: panels
    }
  };
}